var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',{attrs:{"hint":_vm.$t('enter_emails_separated_commas'),"rules":_vm.rules,"label":"Email","autocomplete":"email","rows":"3","outlined":"","autofocus":""},model:{value:(_vm.contentLocal),callback:function ($$v) {_vm.contentLocal=$$v},expression:"contentLocal"}})
}
var staticRenderFns = []

export { render, staticRenderFns }